module.exports = __webpack_public_path__ + "img/ky.d5c801ae.svg";